import React from "react";
import styles from "./nodes-counter-selector.module.scss";
import { NodesSelectionNumberEyes } from "../nodes-selection-number-eyes/nodes-selection-number-eyes";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import { useNodesCounterSelectorHook } from "./use-nodes-counter-selector-hook";
import { useI18N } from "@src/language/language-context";

interface NodesCounterSelectorProps {
  structure: "machine" | "initial";
}

const cssClassName = "nodes-counter-selector";

export const NodesCounterSelector = ({
  structure,
}: NodesCounterSelectorProps) => {
  const {
    selectedNodesCount,
    hiddenCount,
    filteredFlatMapSize,
    selectedFilteredNodesCount,
    handleClickDeselectAll,
    handleClickDeselectAllFiltered,
    handleClickSelectAll,
    handleClickSelectAllFiltered,
  } = useNodesCounterSelectorHook(structure);

  const i18n = useI18N();

  const texts = {
    selectAll: i18n("modules.nodesCounterSelector.selectAll"),
    selectAllFiltered: i18n("modules.nodesCounterSelector.selectAllFiltered"),
    deselectAll: i18n("modules.nodesCounterSelector.deselectAll"),
    deselectAllFiltered: i18n(
      "modules.nodesCounterSelector.deselectAllFiltered",
    ),
    noItemsSelected: i18n("modules.nodesCounterSelector.noItemsSelected"),
    selectedItems: i18n("modules.nodesCounterSelector.selectedItems"),
  };

  return (
    <div className={styles[cssClassName]}>
      <span className={styles[`${cssClassName}__text`]}>
        {selectedNodesCount > 0
          ? selectedNodesCount + " " + texts.selectedItems
          : texts.noItemsSelected}
      </span>
      {filteredFlatMapSize > 0 && (
        <>
          <NodesSelectionNumberEyes
            type="shown"
            amount={selectedFilteredNodesCount}
          />
          <NodesSelectionNumberEyes type="hidden" amount={hiddenCount} />
        </>
      )}
      <span className={styles[`${cssClassName}__text-button-wrapper`]}>
        {filteredFlatMapSize > 0 ? (
          <TextButton
            clickHandler={
              selectedFilteredNodesCount > 0
                ? handleClickDeselectAllFiltered
                : handleClickSelectAllFiltered
            }
            text={
              selectedFilteredNodesCount > 0
                ? texts.deselectAllFiltered
                : texts.selectAllFiltered
            }
            variant={"blue"}
          />
        ) : (
          <TextButton
            clickHandler={
              selectedNodesCount > 0
                ? handleClickDeselectAll
                : handleClickSelectAll
            }
            text={selectedNodesCount > 0 ? texts.deselectAll : texts.selectAll}
            variant={"blue"}
          />
        )}
      </span>
    </div>
  );
};
